export default {
  title: {
    id: 'report_illicit_content_title',
    defaultMessage: 'Report illegal or dangerous content or products',
  },

  successTitle: {
    id: 'report_illicit_content_success_title',
    defaultMessage: 'Your report was submitted.',
  },

  successDescription: {
    id: 'report_illicit_content_success_description',
    defaultMessage: 'You will receive an email notification shortly.',
  },

  descriptionIntro: {
    id: 'report_illicit_content_description_intro',
    defaultMessage:
      'This form allows you to report content, a product that you believe to be illegal, including a dangerous or non-compliant product.',
  },

  descriptionInstruction: {
    id: 'report_illicit_content_description_instruction',
    defaultMessage:
      'Please provide accurate information so that we can identify the item concerned and assess your report.',
  },

  infoBlockTitle: {
    id: 'report_illicit_content_info_block_title',
    defaultMessage: 'Need help with an order?',
  },

  infoBlockContent: {
    id: 'report_illicit_content_info_block_content',
    defaultMessage:
      'This form is only for reporting illicit content. For any request about an order, please go to your orders page.',
  },

  infoBlockCta: {
    id: 'report_illicit_content_info_block_cta',
    defaultMessage: 'Go to my orders',
  },
}
